import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { QualifierValue } from "../../internal/qualifier/QualifierValue.js";
/**
 * @memberOf Qualifiers.Format
 * @extends {SDK.QualifierValue}
 */
var FormatQualifier = /*#__PURE__*/function (_QualifierValue) {
  function FormatQualifier(val) {
    var _this;
    _classCallCheck(this, FormatQualifier);
    _this = _callSuper(this, FormatQualifier, [val]);
    _this.val = val;
    return _this;
  }
  _inherits(FormatQualifier, _QualifierValue);
  return _createClass(FormatQualifier, [{
    key: "getValue",
    value: function getValue() {
      return this.val;
    }
  }]);
}(QualifierValue);
export { FormatQualifier };